module.exports = __webpack_public_path__ + "img/loja_atualizada_icon.a7e86b2d.svg";